import chalk from "chalk";

/**
 * Handles error logging to Sentry and OpenSearch
 * 
 * @param {Object} message - The message to help debug
 * @param {Object} payload - The meta data to help debug
 */
function debug(message, payload = {}) {
    if (typeof window === 'undefined') {
        console.error(chalk.blue("LOGGER: ", message, payload));
    } else {
        console.log("LOGGER: ", message, payload);
    }
}

export default debug;